import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { Col, Modal, Row } from "react-bootstrap";
import {
  cmsfundercoachdetail,
  cmsfundercoachlist,
  cmsfundermonialdetail,
  cmsfundermoniallist,
  funderdetail,
  fundergallerylist,
  fundermedalslist,
  funderresourceslist,
  funderschoollist,
  fundertourlist,
  medalsdetaillist,
  photoslist,
  playsessionview,
  schooldetails,
  schoolstatementview,
  storylist,
  storyview,
} from "../services/site";
import dotracking from "./trackinglogs";
import { AgGridReact } from "ag-grid-react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

export const Website = () => {
  const { sch, id } = useParams();
  const navigate = useNavigate();

  const [fundname, setFundName] = useState("");
  const [funddesc, setFundDesc] = useState("");
  const [fundmail, setFundMail] = useState("");
  const [fundmob, setFundMob] = useState("");
  const [fundaddr, setFundAddr] = useState("");
  const [logofile, setLogoFile] = useState("");

  const [shead, setSHead] = useState("");
  const [desc, setDesc] = useState("");
  const [simage, setImage] = useState("");
  const [sface, setSFace] = useState("");
  const [sinsta, setSInsta] = useState("");
  const [syoutube, setSYoutube] = useState("");

  const [schlist, setSchList] = useState([]);
  const [schpath, setSchPath] = useState("");

  const [tlist, setTList] = useState([]);
  const [tpath, setTPath] = useState("");

  const [gllist, setGList] = useState([]);
  const [gtpath, setGtPath] = useState("");

  const [reslist, setResList] = useState([]);
  const [respath, setResPath] = useState("");
  const [replist, setRepList] = useState([]);
  const [reppath, setRepPath] = useState("");

  const [stlist, setStList] = useState([]);
  const [stpath, setStPath] = useState("");

  const [tmlist, setTMList] = useState([]);
  const [tmpath, setTMPath] = useState("");

  const [chlist, setChList] = useState([]);
  const [chpath, setChPath] = useState("");

  const [platses, setPlaySes] = useState("0");
  const [mcount, setMCount] = useState("0");
  const [tcount, setTCount] = useState("0");
  const [scount, setSCount] = useState("0");

  const [medlist, setMedList] = useState([]);
  const [mlshow, setMLShow] = useState(false);
  const columnDefs = [
    {
      headerName: "Tournament",
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Name",
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "School",
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Level",
      field: "level",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Position",
      field: "position",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Category",
      field: "category_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    document.title = "Sportz Village - Funder";
    
    window.scrollTo(0, 0);
    funderdetail(id).then((response) => {
      if (response.status === true) {
        var sl = response.data.funders_details.funder_name.toLowerCase();
        sl = sl.trim();
        sl = sl.replace(/ /g, "_");
        window.location.replace('https://pathwayz.sportzvillage.com/funder/#/'+sl+"/" + id);
        setFundName(response.data.funders_details.funder_name);
        setFundDesc(response.data.funders_details.funder_description);
        if (response.data.funders_details.email !== null) {
          setFundMail(response.data.funders_details.email);
        }
        if (response.data.funders_details.mobile !== null) {
          setFundMob(response.data.funders_details.mobile);
        }
        if (response.data.funders_details.address !== null) {
          setFundAddr(response.data.funders_details.address);
        }
        if (response.data.funders_details.logo !== null) {
          setLogoFile(
            response.data.logo_path + response.data.funders_details.logo
          );
        }
      }
    });

    schoolstatementview(id).then((response) => {
      if (response.status === true) {
        if (response.data.school_statement !== null) {
          setSHead(response.data.school_statement.heading);
          setDesc(response.data.school_statement.description);
          if (response.data.school_statement.fb_url !== null) {
            setSFace(response.data.school_statement.fb_url);
          }
          if (response.data.school_statement.insta_url !== null) {
            setSInsta(response.data.school_statement.insta_url);
          }
          if (response.data.school_statement.youtube_url !== null) {
            setSYoutube(response.data.school_statement.youtube_url);
          }

          if (response.data.school_statement.image_path !== null) {
            setImage(
              response.data.logo_path +
                response.data.school_statement.image_path
            );
          }
        }
      }
    });

    funderschoollist(id).then((response) => {
      if (response.status === true) {
        setSchList(response.data.school_list);
        setSchPath(response.data.logo_path);
      }
    });

    fundertourlist(id).then((response) => {
      if (response.status === true) {
        let arr = [];
        setTPath(response.data.img_path);
        if (response.data.tournament_list.length > 0) {
          for (let i = 0; i < response.data.tournament_list.length; i++) {
            var chk = "";
            if (
              moment(new Date()).format("YYYY-MM-DD") >
              moment(
                response.data.tournament_list[i].entry_deadline_date
              ).format("YYYY-MM-DD")
            ) {
              chk = "Closed";
            }
            arr.push({
              id: response.data.tournament_list[i].id,
              start_date: response.data.tournament_list[i].start_date,
              meet_name: response.data.tournament_list[i].meet_name,
              type: "Tournament",
              exttype: "Internal",
              entry_open: response.data.tournament_list[i].entry_open,
              entry_deadline_date:
                response.data.tournament_list[i].entry_deadline_date,
              school_id: response.data.tournament_list[i].school_id,
              status: chk,
              meet_url: response.data.tournament_list[i].meet_url,
              tournament_logo: response.data.tournament_list[i].tournament_logo,
            });
          }
        }

        if (response.data.all_ext_tournament_list.length > 0) {
          for (
            let i = 0;
            i < response.data.all_ext_tournament_list.length;
            i++
          ) {
            var chk = "";
            if (
              moment(new Date()).format("YYYY-MM-DD") >
              moment(
                response.data.all_ext_tournament_list[i].entry_deadline_date
              ).format("YYYY-MM-DD")
            ) {
              chk = "Closed";
            }
            arr.push({
              id: response.data.all_ext_tournament_list[i].id,
              start_date: response.data.all_ext_tournament_list[i].start_date,
              meet_name: response.data.all_ext_tournament_list[i].meet_name,
              type: "Tournament",
              exttype: "External",
              entry_open: "",
              entry_deadline_date: "",
              school_id: response.data.all_ext_tournament_list[i].school_id,
              status: "",
              meet_url: "",
              tournament_logo: "",
            });
          }
        }

        if (response.data.event_list.length > 0) {
          for (let i = 0; i < response.data.event_list.length; i++) {
            var chk = "";
            if (
              moment(new Date()).format("YYYY-MM-DD") >
              moment(response.data.event_list[i].entry_end_date).format(
                "YYYY-MM-DD"
              )
            ) {
              chk = "Closed";
            }
            arr.push({
              id: response.data.event_list[i].id,
              start_date: response.data.event_list[i].start_date,
              meet_name: response.data.event_list[i].event_name,
              type: "Event",
              exttype: "Event",
              entry_open: response.data.event_list[i].entry_start_date,
              entry_deadline_date: response.data.event_list[i].entry_end_date,
              school_id: response.data.event_list[i].school_id,
              status: chk,
              meet_url: response.data.event_list[i].meet_url,
              tournament_logo: "",
            });
          }
        }
        setTList(arr);
        setTCount(
          parseInt(response.data.all_tournament_list.length) +
            parseInt(response.data.all_ext_tournament_list.length) +
            parseInt(response.data.all_achievement_tournament_list.length)
        );
      }
    });
    fundergallerylist(id).then((response) => {
      if (response.status === true) {
        setGtPath(response.data.img_path);
        setGList(response.data.gallery_list);
      }
    });

    funderresourceslist(id).then((res) => {
      if (res.status === true) {
        const fdata = res.data.funder_reports.filter((item) => {
          return item.selected_status != 2;
        });
        if (fdata !== undefined) {
          setRepList(fdata);
        }
        setRepPath(res.data.funder_reports_path);
        setResPath(res.data.logo_path);
        setResList(res.data.resources_list);
      }
    });

    storylist(id, 2).then((res) => {
      if (res.status === true) {
        setStPath(res.data.logo_path);
        setStList(res.data.success_stories_list);
      }
    });

    cmsfundermoniallist(id, 2).then((res) => {
      if (res.status === true) {
        setTMPath(res.data.logo_path);
        setTMList(res.data.testimonial_list);
      }
    });

    cmsfundercoachlist(id, 2).then((res) => {
      if (res.status === true) {
        setChPath(res.data.logo_path);
        setChList(res.data.coach_profiles_list);
      }
    });

    const temp = new FormData();
    temp.append("year", 0);
    temp.append("sports", 0);
    temp.append("funder_id", id);

    fundermedalslist(temp).then((res) => {
      if (res.status === true) {
        let mcnt = 0;
        let tcnt = 0;
        let scnt = 0;
        for (let i = 0; i < res.data.length; i++) {
          if (typeof res.data[i].meet_count === "string") {
            tcnt += parseInt(res.data[i].meet_count);
          } else {
            tcnt += res.data[i].meet_count;
          }

          if (typeof res.data[i].participants === "string") {
            scnt += parseInt(res.data[i].participants);
          } else {
            scnt += res.data[i].participants;
          }

          if (typeof res.data[i].total_achievements === "string") {
            mcnt += parseInt(res.data[i].total_achievements);
          } else {
            mcnt += res.data[i].total_achievements;
          }
        }
        setMCount(mcnt);
        // setTCount(tcnt);
        setSCount(scnt);
      }
    });

    playsessionview(id).then((res) => {
      if (res.status === true) {
        if (res.data.play_sessions !== null) {
          setPlaySes(res.data.play_sessions.play_sessions);
        }
      }
    });

    medalsdetaillist(id, 2).then((response) => {
      if (response.status === true) {
        let arr = [];
        let arr1 = [];
        if (response.data.other_achivements.length !== 0) {
          arr1 = response.data.other_achivements;
        }
        if (response.data.football_achievements.length !== 0) {
          arr = response.data.football_achievements;
        }
        let arr2 = arr1.concat(arr);
        setMedList(arr2);
      }
    });

    dotracking(2, id, "Home", 0, id);
  }, []);

  const [syshow, setSyShow] = useState(false);
  const [stitle, setSTitle] = useState("");
  const [sdesc, setSDesc] = useState("");
  const [sphto, setSImage] = useState("");
  const [sdesc1, setSDesc1] = useState("");
  function handlestory(sid) {
    storyview(sid).then((response) => {
      if (response.status === true) {
        setSyShow(true);

        setSTitle(response.data.success_stories_details.article_title);
        setSDesc(response.data.success_stories_details.article_description);
        if (response.data.success_stories_details.article_image !== null) {
          setSImage(
            response.data.logo_path +
              response.data.success_stories_details.article_image
          );
        }

        setSDesc1(response.data.success_stories_details.article_content);
      }
    });
  }

  function handlestoryclose() {
    setSyShow(false);
    setSTitle("");
    setSDesc("");
    setSImage("");
    setSDesc1("");
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const tourresponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const stresponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const glresponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  function errorhandle(ev) {
    ev.target.src = require("../assets/img/logo-pathway.png");
    ev.target.onerror = null;
  }

  function errorschool(ev) {
    ev.target.src = require("../assets/img/school.png");
    ev.target.onerror = null;
  }

  function errortour(ev) {
    ev.target.src = require("../assets/img/logo_epl.png");
    ev.target.onerror = null;
  }

  function errorslogo(ev) {
    ev.target.src = require("../assets/img/slogo.png");
    ev.target.onerror = null;
  }

  const [gcpshow, setGCPShow] = useState(false);
  const [gphoto, setGallery] = useState([]);
  function handlegcpopen(cid) {
    setGCPShow(true);
    photoslist(cid).then((response) => {
      if (response.status === true) {
        if (response.data.tournamentlist.length !== 0) {
          let arr1 = [];
          for (let i = 0; i < response.data.tournamentlist.length; i++) {
            arr1.push({
              id: response.data.tournamentlist[i].id,
              src:
                response.data.tournamentimage_path +
                response.data.tournamentlist[i].imagename,
            });
          }
          setGallery(arr1);
        }
      }
    });
  }
  function handlegcpclose() {
    setGCPShow(false);
    setGallery([]);
  }

  const [shareUrl, setShare] = useState("");
  const [show, setShow] = useState(false);

  function handleshow(timg) {
    setShare(timg);
    setShow(true);
    dotracking(2, id, "Gallery", 0, timg);
  }
  const handleclose = () => {
    setShow(false);
  };

  function tourdet(tid, ttype) {
    dotracking(2, id, "Tournament", tid, id);
    if (ttype == "External") {
      navigate(`/externaltournamentdetails/${id}/${tid}`);
    } else {
      navigate(`/fundertournamentdetails/${id}/${tid}`);
    }
  }

  function eventdet(tid) {
    dotracking(2, id, "Event", tid, id);
    navigate(`/fundereventdetails/${id}/${tid}`);
  }

  const [ishow, setIShow] = useState(false);
  const [pimage, setPImage] = useState(false);
  const [pimgtype, setPImgType] = useState("");
  const [pimgurl, setPImgUrl] = useState("");
  const [prem, setPRem] = useState("");
  const [ptitle, setPTitle] = useState("");

  function handlerpop(hdes, hfile, htit) {
    setPTitle(htit);
    setPImage(reppath + hfile);
    setPRem(hdes);
    setPImgUrl("file");
    setIShow(true);
    const fd = hfile.split(".")[1];
    const df = fd.toUpperCase();
    setPImgType(df);
  }

  function handlepop(img, itype, ifile, irem) {
    setPTitle("");
    if (itype === "Video") {
      if (ifile === "url") {
        let newstr1 = img.substr(img.length - 11);
        let curvideo = "";
        let res = img.substring(0, 23);
        curvideo = "https://www.youtube.com";
        if (curvideo == res) {
          setPImage(`https://www.youtube.com/embed/${newstr1}`);
        }
      } else {
        setPImage(respath + img);
      }
    } else {
      setPImage(respath + img);
    }
    setPRem(irem);
    setPImgUrl(ifile);
    setIShow(true);
    setPImgType(itype);
  }

  function imageclose() {
    setIShow(false);
    setPImage("");
    setPRem("");
  }

  const [sdet, setSDet] = useState("");
  const [scshow, setSCShow] = useState(false);
  function schoolinfo(sid) {
    schooldetails(sid).then((res) => {
      if (res.status === true) {
        setSCShow(true);
        if (res.data.details !== null) {
          setSDet(res.data.details);
        }
      }
    });
  }

  function schclose() {
    setSCShow(false);
    setSDet("");
  }

  function imagetmoniclose() {
    setITShow(false);
    setTName("");
    setTDesc("");
    setTType("");
    setTImage("");
  }
  const [timage, setTImage] = useState("");
  const [itshow, setITShow] = useState(false);
  const [tname, setTName] = useState("");
  const [tdesc, setTDesc] = useState("");
  const [ttype, setTType] = useState("");
  function handletpop(sid) {
    cmsfundermonialdetail(sid).then((response) => {
      if (response.status === true) {
        setITShow(true);

        setTName(response.data.testimonia_details.testimonial_name);
        setTDesc(response.data.testimonia_details.testimonial_description);
        setTType(response.data.testimonia_details.testimonial_file_type);
        if (
          response.data.testimonia_details.testimonial_file_or_url !== null &&
          response.data.testimonia_details.testimonial_file_type === "file"
        ) {
          setTImage(
            response.data.logo_path +
              response.data.testimonia_details.testimonial_file_or_url
          );
        } else if (
          response.data.testimonia_details.testimonial_file_type === "URL"
        ) {
          let newstr1 =
            response.data.testimonia_details.testimonial_file_or_url.substr(
              response.data.testimonia_details.testimonial_file_or_url.length -
                11
            );
          let curvideo = "";
          let res =
            response.data.testimonia_details.testimonial_file_or_url.substring(
              0,
              23
            );
          curvideo = "https://www.youtube.com";
          if (curvideo == res) {
            setTImage(`https://www.youtube.com/embed/${newstr1}`);
          }
        }
      }
    });
  }
  const [cyshow, setCyShow] = useState(false);
  const [cname, setCName] = useState("");
  const [cdesc, setCDesc] = useState("");
  const [cphoto, setCPhoto] = useState("");
  function handlecoach(sid) {
    cmsfundercoachdetail(sid).then((response) => {
      if (response.status === true) {
        setCyShow(true);
        setCName(response.data.coach_profiles_details.coach_name);
        setCDesc(response.data.coach_profiles_details.coach_description);
        if (response.data.coach_profiles_details.coach_photo !== null) {
          setCPhoto(
            response.data.logo_path +
              response.data.coach_profiles_details.coach_photo
          );
        }
      }
    });
  }

  function handlecoachclose() {
    setCyShow(false);
    setCName("");
    setCDesc("");
    setCPhoto("");
  }

  return (
    <div>
      <div className="vs-menu-wrapper">
        <div className="vs-menu-area text-center">
          <div className="mobile-logo">
            <a href="index.html">
              <img
                src={logofile}
                alt="Marino"
                onError={(e) => errorhandle(e)}
              />
            </a>
          </div>
        </div>
      </div>
      <header className="vs-header header-layout5">
        <div className="header-top">
          <div className="vs-container4"></div>
        </div>
        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="vs-container2">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-3 col-sm-5 align-self-stretch">
                  <div className="vs-logo style2">
                    <a className="">
                      <img
                        src={logofile}
                        alt="logo"
                        onError={(e) => errorhandle(e)}
                      />
                    </a>
                    <a className="sticky-logo">
                      <img
                        src={logofile}
                        alt="logo"
                        onError={(e) => errorhandle(e)}
                      />
                    </a>
                  </div>
                </div>
                <div className="col-md-6 col-sm-2 mx-0 ">
                  <div className="row gx-50 align-items-center d-none d-md-block">
                    <div className="col d-flex align-items-center justify-content-center">
                      <nav className="main-menu">
                        <ul>
                          <li className="menu-item-has-children">{fundname}</li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-5 text-end">
                  <img
                    src={require("../assets/img/logo_sv.png")}
                    alt=""
                    className="sponsorlogo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="hero-layout1 style2 position-relative">
        <div
          className="vs-carousel"
          data-arrows="true"
          data-dots="false"
          data-fade="true"
        >
          <div className="hero-inner">
            <div
              className="hero-bg background-image"
              data-bg-src="assets/img/bg/testi-bg-1-1.jpg"
            ></div>
            <div className="container">
              <div className="row">
                <div className="col-md-7">
                  <div className="hero-content">
                    <h1 className="hero-title">{shead}</h1>
                    <p className="hero-text">{desc}</p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div
                    style={{
                      margin: 0,
                      display: "grid",
                      minHeight: "50vh",
                      gridAutoFlow: "column",
                      placeContent: "center",
                      gap: "40px",
                    }}
                  >
                    {simage !== "" && (
                      <img src={simage} className="bannerimg" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="space service">
        <div className="container">
          <div
            className="title-area text-center wow fadeInUp wow-animated"
            data-wow-delay="0.3s"
          >
            <h2 className="sec-title">School Information</h2>
            <div className="sec-line"></div>
          </div>

          <div className="row vs-carousel">
            <Carousel
              swipeable={true}
              draggable={true}
              showDots={false}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={5000}
              keyBoardControl={true}
              customTransition="all .5"
              transitionDuration={500}
              containerclassName="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              // deviceType={this.props.deviceType}
              dotListclassName="custom-dot-list-style"
              itemclassName="carousel-item-padding-40-px"
            >
              {schlist.map((data, i) => {
                return (
                  <div className="col-auto px-2" key={i}>
                    <div
                      className="service-style1"
                      onClick={() => schoolinfo(data.school_unique_no)}
                    >
                      <div className="service-img">
                        <img
                          onError={(e) => errorschool(e)}
                          src="../assets/img/school.png"
                          alt="service thumbnail"
                        />
                      </div>
                      <div className="service-icon">
                        <img
                          src={schpath + data.school_logo}
                          alt="icon"
                          onError={(e) => errorslogo(e)}
                        />
                      </div>
                      <h3 className="service-title h6">
                        <a className="text-inherit">{data.school_name}</a>
                      </h3>
                      <div className="link-btn">
                        <a>
                          Know More <i className="far fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Carousel>

            <Modal show={scshow} size="xl">
              <Modal.Header>
                <h6>School Details</h6>
              </Modal.Header>
              <Modal.Body>
                <div className="testi-content">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">School Name</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {sdet.school_name}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">School CHID</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {sdet.school_unique_no}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">State</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {sdet.state_name}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">District</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {sdet.district_name}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">City</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{sdet.city_name}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Address</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{sdet.address}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <img
                        src={schpath + sdet.school_logo}
                        width="200px"
                        height="200px"
                        alt="testi-img"
                        onError={(e) => errorslogo(e)}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="text-right">
                  <a className="btn btn-danger" onClick={schclose}>
                    <i className="fa fa-times"></i> Close
                  </a>
                </div>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </section>
      {tlist.length !== 0 && (
        <section
          className="shop-layout1 bg-white space-top space-extra-bottom"
          style={{
            backgroundImage: `url(${require("../assets/img/bg/shop-bg2.png")})`,
          }}
        >
          <div className="container">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Tournaments &amp; Events</h2>
              <div className="sec-line"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={tourresponsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                // deviceType={this.props.deviceType}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {tlist.map((item, i) => {
                  return (
                    <div className="col-auto px-2" key={i}>
                      <div className="product-style2">
                        <div className="product-img">
                          <div className="clipped">
                            {item.type == "Tournament" &&
                              item.tournament_logo !== "" && (
                                <img
                                  height="150px"
                                  src={tpath + item.tournament_logo}
                                  onError={(e) => errortour(e)}
                                />
                              )}
                            {item.type == "Tournament" &&
                              item.tournament_logo == "" && (
                                <img
                                  height="150px"
                                  src={require("../assets/img/logo_epl.png")}
                                />
                              )}
                            {item.type == "Event" && (
                              <img
                                src={require("../assets/img/logo-pathway.png")}
                                alt="#"
                              />
                            )}
                          </div>
                        </div>
                        <div className="product-body">
                          <div className="product-img2">
                            <img
                              src={
                                require("../assets/img/shop/shop-bg-shep.svg")
                                  .default
                              }
                              alt="shop"
                            />
                          </div>
                          <div className="product-content">
                            <span className="product-price">
                              {/* {item.start_Date} */}
                              {moment(item.start_date).format("DD, MMMM YYYY")}
                            </span>
                            <h3 className="product-title">{item.meet_name}</h3>
                            <div className="product-rating">
                              {item.type == "Tournament" && (
                                <a
                                  className="vs-btn style3"
                                  tabIndex="-1"
                                  onClick={() => tourdet(item.id, item.exttype)}
                                >
                                  See Tournament{" "}
                                  <i className="far fa-arrow-right"></i>
                                </a>
                              )}
                              {item.type == "Event" && (
                                <a
                                  className="vs-btn style3"
                                  tabIndex="-1"
                                  onClick={() => eventdet(item.id)}
                                >
                                  See Event{" "}
                                  <i className="far fa-arrow-right"></i>
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </section>
      )}
      {stlist.length !== 0 && (
        <section className="testimonial-layout1 style2 space">
          <div className="container">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Our Success Stories</h2>
              <div className="sec-line m-auto"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={stresponsive}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {stlist.map((item, i) => (
                  <div className="col-auto px-1" key={i}>
                    <div className="testi-item">
                      <div
                        className="testi-content"
                        onClick={() => handlestory(item.id)}
                      >
                        <div className="testi-img" style={{ height: "150px" }}>
                          <img
                            src={stpath + item.article_image}
                            alt="testi-img"
                          />
                          <span className="testi_quote">
                            <i className="fas fa-quote-right"></i>
                          </span>
                        </div>
                        <div className="testi-inner">
                          <div className="testi-text">
                            <p>{item.article_description}</p>
                          </div>
                          <div className="testi-desc">
                            <div>
                              <h3 className="testi_author">
                                {item.article_title}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              <Modal show={syshow} size="xl">
                <Modal.Header>
                  <h4>Success Stories Details</h4>
                </Modal.Header>
                <Modal.Body>
                  <div className="testi-content">
                    <div className="row">
                      <div className="col-md-6">
                        <img src={sphto} width="100%" alt="testi-img" />
                      </div>
                      <div className="col-md-6">
                        <div className="testi-inner">
                          <div className="testi-desc">
                            <div>
                              <h5 className="testi_author">{stitle}</h5>
                              <span className="testi_degi">{sdesc}</span>
                            </div>
                          </div>

                          <div className="testi-text">
                            <p>
                              <div
                                dangerouslySetInnerHTML={{ __html: sdesc1 }}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="testi-img">
                      <img src={sphto} width="300px" alt="testi-img" />
                    
                    </div>
                    <div className="testi-inner">
                      <div className="testi-desc">
                        <div>
                          <h3 className="testi_author">{stitle}</h3>
                          <span className="testi_degi">{sdesc}</span>
                        </div>
                      </div>

                      <div className="testi-text">
                        <p>
                          <div dangerouslySetInnerHTML={{ __html: sdesc1 }} />
                        </p>
                      </div>
                    </div> */}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="text-right">
                    <a className="btn btn-danger" onClick={handlestoryclose}>
                      <i className="fa fa-times"></i> Close
                    </a>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </section>
      )}

      {tmlist.length !== 0 && (
        <section className="testimonial-layout1 style2 space">
          <div className="container">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Testimonials</h2>
              <div className="sec-line m-auto"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={stresponsive}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {tmlist.map((item, i) => (
                  <div className="col-auto px-1" key={i}>
                    <div className="testi-item">
                      <div
                        className="testi-content"
                        onClick={() => handletpop(item.id)}
                      >
                        <div className="testi-img">
                          {item.testimonial_file_type == "URL" && (
                            <img
                              className="w-100"
                              src={require("../assets/img/video.png")}
                              alt="Blog Img"
                            />
                          )}

                          {item.testimonial_file_type == "file" && (
                            <img
                              className="w-100"
                              src={tmpath + item.testimonial_file_or_url}
                              alt="Blog Img"
                            />
                          )}

                          <span className="testi_quote">
                            <i className="fas fa-quote-right"></i>
                          </span>
                        </div>
                        <div className="testi-inner">
                          <div className="testi-text">
                            <p>{item.testimonial_description}</p>
                          </div>
                          <div className="testi-desc">
                            <div>
                              <h3 className="testi_author">
                                {item.testimonial_name}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              <Modal show={itshow} size="xl" onHide={imagetmoniclose}>
                <Modal.Header>
                  <h6> {tname}</h6>
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        {ttype === "URL" && (
                          <iframe
                            width="100%"
                            height="300"
                            src={timage}
                            frameBorder="0"
                            // allow="autoplay; encrypted-media"
                            allowFullScreen
                            title="Embedded youtube"
                          />
                        )}

                        {ttype === "file" && (
                          <img src={timage} alt="Photo" width="100%" />
                        )}
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <p>{tdesc}</p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={imagetmoniclose}>
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </section>
      )}

      {chlist.length !== 0 && (
        <section className="testimonial-layout1 style2 space">
          <div className="container">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Coach Profiles</h2>
              <div className="sec-line m-auto"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={stresponsive}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {chlist.map((item, i) => (
                  <div className="col-auto px-1" key={i}>
                    <div className="testi-item">
                      <div
                        className="testi-content"
                        onClick={() => handlecoach(item.id)}
                      >
                        <div className="testi-img">
                          <img
                            src={chpath + item.coach_photo}
                            alt="testi-img"
                          />
                          <span className="testi_quote">
                            <i className="fas fa-quote-right"></i>
                          </span>
                        </div>
                        <div className="testi-inner">
                          <div className="testi-text">
                            <p>{item.coach_description}</p>
                          </div>
                          <div className="testi-desc">
                            <div>
                              <h3 className="testi_author">
                                {item.coach_name}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              <Modal show={cyshow} size="xl">
                <Modal.Header>
                  <h4>Coach Profile Details</h4>
                </Modal.Header>
                <Modal.Body>
                  <div className="testi-content">
                    <div className="row">
                      <div className="col-md-6">
                        <img src={cphoto} width="100%" alt="testi-img" />
                      </div>
                      <div className="col-md-6">
                        <div className="testi-inner">
                          <div className="testi-desc">
                            <div>
                              <h3 className="testi_author">{cname}</h3>
                              <span className="testi_degi">{cdesc}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="text-right">
                    <a className="btn btn-danger" onClick={handlecoachclose}>
                      <i className="fa fa-times"></i> Close
                    </a>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </section>
      )}

      <section
        className="space position-relative counter"
        style={{
          backgroundImage: `url(${require("../assets/img/bg/counter-bg3.png")})`,
        }}
      >
        <div className="vs-container2">
          <div className="container">
            <div className="row g-5 justify-content-lg-between justify-content-center">
              <div className="col-lg-auto col-md-6">
                <div className="media-style3">
                  <div className="media-icon">
                    <div className="icon">
                      <i className="fa fa-school"></i>
                    </div>
                  </div>
                  <div className="media-counter">
                    <h2 className="media-title counter-number" data-count="11">
                      {schlist.length}
                    </h2>
                    <p className="media-text">Schools</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-auto col-md-6">
                <div
                  className="media-style3"
                  onClick={() => setMLShow(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="media-icon">
                    <div className="icon">
                      <img
                        src={require("../assets/img/icon/ci-2-1.svg").default}
                        alt="icon"
                      />
                    </div>
                  </div>
                  <div className="media-counter">
                    <h2 className="media-title counter-number" data-count="11">
                      {mcount}
                    </h2>
                    <p
                      className="media-text"
                      style={{ textDecoration: "underline" }}
                    >
                      Medals
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-auto col-md-6">
                <div className="media-style3">
                  <div className="media-icon">
                    <div className="icon">
                      <img
                        src={require("../assets/img/icon/ci-2-2.svg").default}
                        alt="icon"
                      />
                    </div>
                  </div>
                  <div className="media-counter">
                    <h2
                      className="media-title counter-number"
                      data-count="4700"
                    >
                      {platses}
                    </h2>
                    <p className="media-text">Sports Represented</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-auto col-md-6">
                <div className="media-style3">
                  <div className="media-icon">
                    <div className="icon">
                      <img
                        src={require("../assets/img/icon/ci-2-3.svg").default}
                        alt="icon"
                      />
                    </div>
                  </div>
                  <div className="media-counter">
                    <h2 className="media-title counter-number" data-count="102">
                      {scount}
                    </h2>
                    <p className="media-text">Total Participation</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-auto col-md-6">
                <div className="media-style3">
                  <div className="media-icon">
                    <div className="icon">
                      <img
                        src={require("../assets/img/icon/ci-2-4.svg").default}
                        alt="icon"
                      />
                    </div>
                  </div>
                  <div className="media-counter">
                    <h2 className="media-title counter-number" data-count="45">
                      {tcount}
                    </h2>
                    <p className="media-text">Tournaments Participated</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal show={mlshow} size="xl">
        <Modal.Header>
          <h6>Achievements List</h6>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="ag-theme-alpine ag-style mt-2">
              <AgGridReact
                columnDefs={columnDefs}
                rowData={medlist}
                pagination="true"
                paginationPageSize="10"
                suppressExcelExport={true}
                suppressDragLeaveHidesColumns={true}
                sortingOrder={["asc", "desc"]}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger mt-2" onClick={() => setMLShow(false)}>
            <i className="fa fa-times"></i> Close
          </a>
        </Modal.Footer>
      </Modal>
      {gllist.length !== 0 && (
        <section className="space">
          <div className="container-fluid">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Gallery</h2>
              <div className="sec-line"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={glresponsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                // deviceType={this.props.deviceType}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {gllist.map((item, index) => {
                  return (
                    <div className="col-auto px-2" key={index}>
                      <div className="service_style5">
                        <div className="service_inner mega-hover">
                          <div className="service_img">
                            <img
                              src={gtpath + item.imagename}
                              onError={(e) => errorhandle(e)}
                              alt="service-img"
                            />
                          </div>
                          <div className="service_icon">
                            <a
                              className="icon-btn"
                              onClick={() => handlegcpopen(item.tournament_id)}
                            >
                              <i className="far fa-arrow-up"></i>
                            </a>
                          </div>
                          <div className="service_content">
                            <a>
                              <h2 className="service_title">
                                {item.meet_name}
                              </h2>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>

              <Modal show={gcpshow} size="xl">
                <Modal.Header>
                  <h4>Gallery</h4>
                </Modal.Header>
                <Modal.Body>
                  <div className="row">
                    {gphoto.map((item, index) => {
                      return (
                        <div
                          className="col-md-2 mt-4"
                          key={index}
                          style={{ position: "relative" }}
                        >
                          <a
                            className="photo-share"
                            onClick={() => handleshow(item.src)}
                          >
                            <i
                              className="fas fa-share fa-lg"
                              style={{ color: "#fff" }}
                            ></i>
                          </a>
                          <img
                            className="photoimg"
                            src={item.src}
                            height="100px"
                            alt="Photo"
                          />
                        </div>
                      );
                    })}
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="text-right border-top mt-2">
                    <a className="btn btn-danger mt-2" onClick={handlegcpclose}>
                      <i className="fa fa-times"></i> Close
                    </a>
                  </div>
                </Modal.Footer>
              </Modal>

              <Modal show={show} size="lg">
                <Modal.Header>
                  <h4>Share Photos</h4>
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mt-3">
                    <div className="text-center">
                      <WhatsappShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <WhatsappIcon size={44} round={true} />
                      </WhatsappShareButton>
                      <FacebookShareButton
                        url={shareUrl}
                        quote="Hey, check out my photos!"
                        className="me-3"
                      >
                        <FacebookIcon size={44}></FacebookIcon>
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <TwitterIcon size={44}></TwitterIcon>
                      </TwitterShareButton>
                    </div>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <div className="text-right border-top mt-2">
                    <a className="btn btn-danger mt-2" onClick={handleclose}>
                      <i className="fa fa-times"></i> Close
                    </a>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </section>
      )}

      {(reslist.length !== 0 || replist.length !== 0) && (
        <section className="space-bottom blog-layout1">
          <div className="container">
            <div
              className="title-area text-center wow fadeInUp wow-animated"
              data-wow-delay="0.3s"
            >
              <h2 className="sec-title">Resources</h2>
              <div className="sec-line"></div>
            </div>
            <div className="row vs-carousel">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={glresponsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={false}
                autoPlaySpeed={5000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerclassName="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                // deviceType={this.props.deviceType}
                dotListclassName="custom-dot-list-style"
                itemclassName="carousel-item-padding-40-px"
              >
                {replist.map((item, index) => {
                  return (
                    <div className="col-auto px-2" key={index}>
                      <div className="vs-blog blog-style3">
                        <div className="blog-img" style={{ height: "150px" }}>
                          {item.tag_name == "Reports" && (
                            <a className="photogal-star">
                              <i className="fa fa-file fa-lg"></i>
                            </a>
                          )}
                          <a
                            onClick={(e) =>
                              handlepop(
                                item.file_name,
                                item.file_type,
                                item.file_or_url,
                                item.remarks
                              )
                            }
                          >
                            {item.file_name.split(".")[1] == "pdf" && (
                              <img
                                height="150px"
                                className="w-100"
                                src={require("../assets/img/pdf.png")}
                                alt="Blog Img"
                              />
                            )}
                            {item.file_name.split(".")[1] != "pdf" && (
                              <img
                                height="150px"
                                className="w-100"
                                src={reppath + item.file_name}
                                alt="Blog Img"
                              />
                            )}{" "}
                          </a>
                        </div>
                        {/* <div className="blog-content">
                          <h4 className="blog-title">
                            <span className="blogline">
                              {item.report_title}
                            </span>
                          </h4>
                        </div> */}
                      </div>
                    </div>
                  );
                })}

                {reslist.map((item, index) => {
                  return (
                    <div className="col-auto px-2" key={index}>
                      <div className="vs-blog blog-style3">
                        <div className="blog-img" style={{ height: "150px" }}>
                          <a
                            onClick={(e) =>
                              handlepop(
                                item.file_name,
                                item.file_type,
                                item.file_or_url,
                                item.remarks
                              )
                            }
                          >
                            {item.file_type == "PDF" && (
                              <img
                                height="150px"
                                className="w-100"
                                src={require("../assets/img/pdf.png")}
                                alt="Blog Img"
                              />
                            )}
                            {item.file_type == "Video" && (
                              <img
                                height="150px"
                                className="w-100"
                                src={require("../assets/img/video.png")}
                                alt="Blog Img"
                              />
                            )}

                            {item.file_type == "Photo" && (
                              <img
                                height="150px"
                                className="w-100"
                                src={respath + item.file_name}
                                alt="Blog Img"
                              />
                            )}
                          </a>
                        </div>
                        {/* <div className="blog-content">
                 <h4 className="blog-title">
                   <span className="blogline">{item.tag_name}</span>
                 </h4>
               </div> */}
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </section>
      )}

      <Modal show={ishow} size="xl" onHide={imageclose}>
        <Modal.Header>
          {ptitle !== "" && <h6>{ptitle}</h6>}
          {ptitle === "" && <h6> Resources</h6>}
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={12} md={12}>
              <div className="form-group">
                {pimgtype === "Video" && pimgurl === "url" && (
                  <iframe
                    width="100%"
                    height="300"
                    src={pimage}
                    frameBorder="0"
                    // allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                )}

                {pimgtype === "Video" && pimgurl !== "url" && (
                  <video controls width="100%" height="300">
                    <source src={pimage} type="video/mp4" />
                  </video>
                )}

                {pimgtype === "PDF" && (
                  <iframe
                    width="100%"
                    height="400"
                    src={pimage}
                    allowFullScreen
                  />
                )}

                {pimgtype !== "PDF" && (
                  <img src={pimage} alt="Photo" width="100%" />
                )}
              </div>
            </Col>
            <Col lg={12} md={12}>
              <p>{prem}</p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger" onClick={imageclose}>
            Close
          </a>
        </Modal.Footer>
      </Modal>

      <footer className="footer-layout1 footer-wrapper bg-title space-top">
        <div className="widget-area">
          <div className="container">
            <div className="row gx-5">
              <div className="col-md-6 col-xl-5">
                <div className="widget footer-widget">
                  <img
                    src={logofile}
                    alt="footer"
                    onError={(e) => errorhandle(e)}
                  />
                  <p className="footer-text text-white">{funddesc}</p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3"></div>
              <div className="col-md-6 col-xl-4">
                <div className="contact-style1">
                  <h4 className="contact-title mb-0">Contact Details</h4>
                  <p className="contact-text">
                    Contact to get every single updates
                  </p>
                  <div className="vs-widget-about">
                    {fundaddr !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-map-marker-alt"></i>
                          <span>{fundaddr}</span>
                        </a>
                      </p>
                    )}

                    {fundmail !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-envelope"></i>
                          <span>{fundmail}</span>
                        </a>
                      </p>
                    )}

                    {fundmob !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-phone-alt"></i>
                          <span>{fundmob}</span>
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="copyright-area">
              <div className="row justify-content-between align-items-center">
                <div className="text-center col-lg-auto">
                  <p className="copyright-text text-white">
                    <i className="fal fa-copyright"></i> Copyright 2024 -{" "}
                    <a
                      href="https://pathwayz.sportzvillage.com/"
                      className="text-secondary"
                      target="_blank"
                    >
                      Sportz Village
                    </a>
                  </p>
                </div>
                <div className="terms-condition  col-lg-auto">
                  <p className="copyright-text text-white">
                    Developed by{" "}
                    <a
                      href="https://sportingindia.tech"
                      className="text-error"
                      target="_blank"
                    >
                      Sportingindia
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
